<div class="member-card" [ngClass]="{ 'unassign-member': !isAssign }">
  <div class="delete-icon">
    <span class="icon" (click)="openDeleteModal(deleteDialog)">
      <mat-icon>close</mat-icon>
    </span>
  </div>
  <div class="badge-icon" *ngIf="isAdmin">
    <img [src]="logo" />
  </div>
  <div class="image" [ngStyle]="{ 'margin-top': isAdmin ? '-33px' : '-10px' }">
    <img [src]="avatar" />
  </div>
  <div class="member-info">
    {{ label }}
  </div>
  <div class="status" *ngIf="isAssign">Assigned</div>
  <div class="assign-btn" *ngIf="!isAssign">
    <a (click)="invite(member.user)">Assign</a>
  </div>
</div>
<ng-template #deleteDialog class="delete-modal">
  <nb-card style="max-width: 100%">
    <nb-card-body style="padding: 40px 0px 45px 0px">
      <div class="delete-content">
        <div class="icon">
          <span> ! </span>
        </div>
        <div class="title">Are you sure you want to unassign this crew member?</div>
        <div class="delete-desc">
          {{ label }}
        </div>
        <div class="delete-btns">
          <a class="cancel-btn" (click)="close()">Cancel</a>
          <a class="delete-btn" (click)="unassign()">Unassign</a>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>
